__webpack_require__.p = "/hhg-game/";